import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Bredcrumb from "../../HomeMain/Bredcrumb";

const Main = () => {
  const { t } = useTranslation();
  const [ytshow, setytshow] = useState();

  return (
    <>
      <Bredcrumb title={t('pages.blog.title')} subtitle={t('pages.blog.subtitle')} />

      <section className="inner-blog pt-120 pb-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="bsingle__post mb-50">
                <div className="bsingle__post-thumb"></div>
                <div className="bsingle__content">
                  <div className="meta-info">
                    <ul>
                      <li>
                        <i className="fa fa-user"></i>{t('blog.author')}
                      </li>
                      <li>
                        <i className="fa fa-calendar-alt"></i> {t('blog.date')}
                      </li>
                    </ul>
                  </div>
                  <h2>
                    <Link to="/balayage">
                      {t('blog.articleTitle')}
                    </Link>
                  </h2>
                  <p>{t('blog.articleExcerpt')}</p>
                  <div className="blog__btn">
                    <Link to="/balayage" className="btn">
                      {t('blog.readMore')}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {ytshow && (
        <>
          <div className="mfp-bg mfp-ready"></div>
          <div className="mfp-wrap mfp-close-btn-in mfp-auto-cursor mfp-ready" tabIndex="-1" style={{ overflow: "hidden" }}>
            <div className="mfp-container mfp-s-ready mfp-iframe-holder">
              <div className="mfp-content">
                <div className="mfp-iframe-scaler">
                  <button title="Close (Esc)" type="button" className="mfp-close" onClick={() => setytshow(false)}>×</button>
                </div>
              </div>
              <div className="mfp-preloader">Loading...</div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Main;
